import { singleMap } from '../map/map-single.js';
import { scrollDetect } from '../includes/scroll-detect.js';
import { mainPads } from '../includes/main-top-padding.js';
import { bx_sliders } from '../includes/bx_sliders.js';

// to detect if element is in viewport -Japs
(function($, win) {
  $.fn.inViewport = function(cb) {
     return this.each(function(i,el){
       function visPx(){
         var H = $(this).height(),
             r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
         return cb.call(el, Math.max(0, t>30? H-t : (b<H?b:H)));
       } visPx();
       $(win).on('resize scroll load', visPx);
     });
  };
}(jQuery, window));

export default {
  init() {
    // bx sliders
    bx_sliders();

    // add body class on scroll up/down
    scrollDetect();

    // use google map anywhere on the site
    singleMap();

    // add 'animate' class if element is visible on screen
      $('*[data-animate=true]').inViewport(function(px){
        if(px){
          $(this).addClass('animate') ;
        }
      });

    let img = $('#hero-slider-image').attr('src');
    if (img) {
      $('#hero').css('background-image', 'url("'+img+'")');
    }

    // add caret down on all header nav with child UL <li><a>link</a> <ul subnav> </li>....
    $('#main-nav-bar li:has(> ul), #sidebar-services ul li:has(> .collapse)').addClass('sfl-has-children');

    // mobile burger menu
    $('#sfl_nav_menu').click(function(){
      $(this).toggleClass('open');
      $('#main-nav-bar').toggleClass('open');
    });

    // scroll to top
    $('#toTop').click(function() {
      $('html, body').animate({scrollTop: '0px'}, 1000);
      return false;
    });

    $('a[href="#quoteForm"]').click( function() {
        $('#quoteForm').modal({
          show: true,
        });
        return false;
    });

    $('.modalLightbox').click( function() {
        $('#modalLightboxImg').attr('src', $(this).attr('href') )
        $('#modalLightbox').modal({
          show: true,
        });
        return false;
    });

    if( $('#header_message').length ) {

      let height = $('#header_message').outerHeight(true)
      $('#navbar').css('margin-top', (height < 50) ? '50px' : height );
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // add top padding on <main> *** fix for fixed top nav
    mainPads();
    $( window ).resize(function() {
      mainPads();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js